import React from 'react'
import ErrorTemplate from './ErrorTemplate'

interface IProps {
    reset: () => void
}

export default function Error500(props: IProps): React.ReactElement {
    return <ErrorTemplate code={500} codeMsg='Error' message='Oops, parece que tivemos um problema, tente novamente!' reset={props.reset} />
}